import React from 'react';

import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

const WHY_CHOOSE_US_IMAGE = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('whychoseus.jpg')}`;

type Feature = {
  title: string;
  description: string;
};

const FEATURES: readonly Feature[] = [
  {
    title: 'Multi-Discipline Expertise',
    description:
      'We bring together expertise across Process Industry, Electrical, Mechanical, and Automation sectors under one roof.',
  },
  {
    title: 'Zimbabwean-Owned & Focused',
    description:
      'As a local firm, we understand the unique challenges and opportunities in the Zimbabwean industrial landscape.',
  },
  {
    title: 'Innovation & Technology',
    description:
      'We bridge traditional industrial processes with modern technological advancement to deliver intelligent solutions.',
  },
  {
    title: 'Proven Track Record',
    description:
      'Trusted by leading companies across Mining, Construction, and Manufacturing sectors for reliable engineering solutions.',
  },
  {
    title: 'Agile & Affordable',
    description:
      'We deliver innovative solutions that are both agile in execution and affordable, ensuring value for your investment.',
  },
  {
    title: 'Comprehensive Support',
    description:
      'From design to implementation and maintenance, we provide end-to-end support throughout your project lifecycle.',
  },
];

export default function HomeWhyChooseUs(): React.ReactElement {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          {/* Image Section */}
          <div className="order-2 lg:order-1">
            <div className="relative h-full min-h-[400px] w-full overflow-hidden rounded-2xl bg-slate-100">
              <img
                src={WHY_CHOOSE_US_IMAGE}
                alt="Why choose Ancient Engineering"
                className="h-full w-full object-cover"
                loading="lazy"
                onError={(e) => {
                  console.error('Failed to load image:', WHY_CHOOSE_US_IMAGE);
                  console.log('Image path attempted:', WHY_CHOOSE_US_IMAGE);
                }}
                onLoad={() => {
                  console.log('HomeWhyChooseUs image loaded successfully:', WHY_CHOOSE_US_IMAGE);
                }}
              />
            </div>
          </div>

          {/* Content Section */}
          <div className="order-1 flex flex-col justify-center lg:order-2">
            <div className="text-left">
              <h2 className="text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl">
                Why Choose Us
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
                Ancient Engineering stands out as your trusted partner for
                comprehensive engineering solutions. Here&apos;s what makes us
                the right choice for your next project.
              </p>
            </div>

            <div className="mt-8 space-y-6">
              {FEATURES.map((feature) => (
                <div key={feature.title} className="flex gap-4 text-left">
                  <div className="flex-shrink-0">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-50 text-sky-600">
                      <CheckCircleOutlinedIcon fontSize="medium" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-slate-900">
                      {feature.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate-600 sm:text-base">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

